/**
 * Site list helpers for WAF Overview Configure drawer.
 * Pure functions so project/RBAC filter cases can be unit-tested.
 */

export function siteUidOf(site) {
  const uid = site?.id || site?.site_uid || "";
  return uid === "" ? "" : String(uid);
}

/**
 * Filter header project siteOptions for the WAF settings drawer.
 * Admins keep every option; others need waf:configure on that site.
 * Incomplete/deleted sites are already excluded upstream via siteOptions.
 */
export function filterWafDrawerSites(siteOptions, { isAdmin = false, canConfigureSite } = {}) {
  const seen = new Set();
  const canConfigure =
    typeof canConfigureSite === "function" ? canConfigureSite : () => false;

  return (siteOptions || []).filter((site) => {
    const uid = siteUidOf(site);
    if (!uid || seen.has(uid)) return false;
    seen.add(uid);
    if (isAdmin) return true;
    return canConfigure(site);
  });
}
